import Swiper from 'swiper';
import {
  Navigation,
  Pagination,
  Scrollbar,
  Autoplay,
  EffectFade,
  Thumbs,
  FreeMode,
} from 'swiper/modules';

export default function initSwiper() {
  document.querySelectorAll<HTMLElement>('.product-gallery').forEach((gallery) => {
    const main = gallery.querySelector('.product-slider') as HTMLElement;
    const thumbs = gallery.querySelector('.product-slider-thumbs') as HTMLElement;
    let thumbsSlider = null;

    if (thumbs) {
      thumbsSlider = new Swiper(thumbs, {
        modules: [FreeMode],
        slidesPerView: 'auto',
        grabCursor: true,
        freeMode: true,
        watchSlidesProgress: true,
      });
    }

    if (main) {
      /* eslint-disable no-new */
      new Swiper(main, {
        modules: [Thumbs],
        grabCursor: true,
        thumbs: {
          swiper: thumbsSlider,
        },
      });
    }
  });

  document.querySelectorAll<HTMLElement>('.swiper-news').forEach((mainSwiper) => {
    /* eslint-disable no-new */
    new Swiper(mainSwiper, {
      slidesPerView: 'auto',
      grabCursor: true,
      spaceBetween: 0,
      breakpoints: {
        1024: {
          cssMode: false,
          enabled: false,
        },
      },
    });
  });

  document.querySelectorAll('.swiper-product-cards-holder').forEach((holder) => {
    const $mainSwiper = holder.querySelector('.swiper-product-cards') as HTMLElement;
    const $navNext = holder.querySelector('.swiper-nav .swiper-button-next') as HTMLElement;
    const $navPrev = holder.querySelector('.swiper-nav .swiper-button-prev') as HTMLElement;
    if ($mainSwiper && $navNext && $navPrev) {
      /* eslint-disable no-new */
      new Swiper($mainSwiper, {
        modules: [Navigation],
        slidesPerView: 'auto',
        grabCursor: true,
        spaceBetween: 0,
        navigation: {
          nextEl: $navNext,
          prevEl: $navPrev,
        },
        breakpoints: {
          1024: {
            cssMode: false,
          },
        },
      });
    }
  });

  document.querySelectorAll('.swiper-cards-holder').forEach((holder) => {
    const $mainSwiper = holder.querySelector('.swiper-cards') as HTMLElement;
    const $navNext = holder.querySelector('.swiper-nav .swiper-button-next') as HTMLElement;
    const $navPrev = holder.querySelector('.swiper-nav .swiper-button-prev') as HTMLElement;
    if ($mainSwiper && $navNext && $navPrev) {
      /* eslint-disable no-new */
      new Swiper($mainSwiper, {
        modules: [Navigation],
        slidesPerView: 'auto',
        grabCursor: true,
        spaceBetween: 0,
        navigation: {
          nextEl: $navNext,
          prevEl: $navPrev,
        },
        breakpoints: {
          1024: {
            cssMode: false,
          },
        },
      });
    }
  });

  document.querySelectorAll<HTMLElement>('.swiper-application-cards').forEach((mainSwiper) => {
    /* eslint-disable no-new */
    new Swiper(mainSwiper, {
      modules: [Scrollbar],
      slidesPerView: 'auto',
      grabCursor: true,
      spaceBetween: 0,
      scrollbar: {
        el: '.swiper-scrollbar',
        hide: false,
        draggable: true,
      },
    });
  });

  document.querySelectorAll('.swiper-images-holder').forEach((holder) => {
    const $mainSwiper = holder.querySelector('.swiper-images') as HTMLElement;
    const $navNext = holder.querySelector('.swiper-nav .swiper-button-next') as HTMLElement;
    const $navPrev = holder.querySelector('.swiper-nav .swiper-button-prev') as HTMLElement;
    /* eslint-disable no-new */
    new Swiper($mainSwiper, {
      slidesPerView: 'auto',
      modules: [Navigation, EffectFade],
      navigation: {
        nextEl: $navNext,
        prevEl: $navPrev,
      },
      effect: 'fade',
      grabCursor: true,
      spaceBetween: 16,
      breakpoints: {
        1024: {
          slidesPerView: 1,
          cssMode: false,
        },
      },
    });
  });

  document.querySelectorAll<HTMLElement>('.swiper-team').forEach((mainSwiper) => {
    /* eslint-disable no-new */
    new Swiper(mainSwiper, {
      slidesPerView: 'auto',
      grabCursor: true,
      spaceBetween: 16,
      breakpoints: {
        1024: {
          cssMode: false,
          spaceBetween: 0,
        },
      },
    });
  });

  document.querySelectorAll<HTMLElement>('.swiper-location').forEach((mainSwiper) => {
    /* eslint-disable no-new */
    new Swiper(mainSwiper, {
      slidesPerView: 'auto',
      grabCursor: true,
      spaceBetween: 16,
      breakpoints: {
        1024: {
          slidesPerView: 3,
          cssMode: false,
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 72,
        },
      },
    });
  });

  document.querySelectorAll<HTMLElement>('.blockquote-carousel').forEach((mainSwiper) => {
    /* eslint-disable no-new */
    new Swiper(mainSwiper, {
      modules: [Pagination, Autoplay],
      loop: true,
      // autoplay: {
      //   delay: 7000,
      //   pauseOnMouseEnter: true,
      // },
      slidesPerView: 1,
      grabCursor: true,
      pagination: {
        el: '.blockquote-carousel-pagination',
        clickable: true,
        renderBullet: (index, className) => `<button type="button" class="${className}" aria-label="Slide ${(index + 1)}"></button>`,
      },
    });
  });

  document.querySelectorAll<HTMLElement>('.cases-carousel').forEach((mainSwiper) => {
    /* eslint-disable no-new */
    new Swiper(mainSwiper, {
      modules: [Pagination, Autoplay],
      loop: true,
      autoplay: {
        delay: 7000,
        pauseOnMouseEnter: true,
      },
      slidesPerView: 1,
      grabCursor: true,
      pagination: {
        el: '.cases-carousel-pagination',
        clickable: true,
        renderBullet: (index, className) => `<button type="button" class="${className}" aria-label="Slide ${(index + 1)}"></button>`,
      },
    });
  });
}
